var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKycFail240X240(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6868 130.513C37.6868 160.256 39.5266 189.811 39.5266 219.54L56.0849 220.46H94.5167C107.086 220.46 119.212 221.861 131.722 221.38C155.443 220.468 202.35 219.54 202.35 219.54C202.35 219.54 204.19 143.858 204.19 133.069C204.19 124.616 203.27 116.553 203.27 108.18C203.27 86.4174 202.932 60.9774 186.712 44.7574C168.431 26.4764 142.12 19 116.799 19C108.842 19 101.781 20.5969 94.3122 22.7307C83.4995 25.8201 56.1913 42.1939 50.7699 53.0366C42.1369 70.3027 36.7668 91.8368 36.7668 111.042C36.7668 117.636 37.6868 124.155 37.6868 130.513Z",
    fill: "white",
    stroke: "#DF5947",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9861 85.8815C113.17 106.018 135.516 131.948 159.295 155.727",
    stroke: "#DF5947",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5635 160.345C111.454 136.332 132.427 108.116 157.564 84.727",
    stroke: "#DF5947",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycFail240X240);
export default __webpack_public_path__ + "static/media/kyc-fail-240x240.22cccabc454a6cbe8f37ea51313dc8dd.svg";
export { ForwardRef as ReactComponent };